export const requestIdleCallback =
  window.requestIdleCallback || window.requestAnimationFrame;
